export default __webpack_public_path__ + "static/media/certify_no_picture.5d29cc89.png";